import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import { Text, ScoreBox } from '@tcaster/tcaster-web-lib';
import { COLOR, FONT_SIZE } from '@tcaster/tcaster-theme';

const NegMarginDev = styled.div`
  margin-top: ${({ loose }) => (loose ? '-0.4em' : 0)};
  margin-bottom: 1em;
`;

const ExamScoreHeader = ({
  title,
  subTitle,
  score,
  canCalculateScore,
  scoreCalculated,
  requireMoreScore,
  errorMessage,
  precision,
}) => (
  <Fragment>
    <Text color={COLOR.primary}>{title}</Text>
    {subTitle && (
      <Text fontWeight="300" fontSize={FONT_SIZE.xsmall} color={COLOR.greyscale.grey3}>
        {subTitle}
      </Text>
    )}
    {canCalculateScore && (
      <Flex justifyContent="space-between" alignItems="center">
        <img src={require('./medal.png')} style={{ maxHeight: 40 }} />
        <ScoreBox
          score={score}
          large
          topLabel
          label={`คะแนนของคุณคือ`}
          textAlign={'right'}
          precision={precision}
        />
      </Flex>
    )}
    {errorMessage && (
      <NegMarginDev loose={score}>
        <Text
          textAlign={'right'}
          fontWeight="300"
          fontSize={FONT_SIZE.xsmall}
          color={COLOR.primary}
        >
          {errorMessage}
        </Text>
      </NegMarginDev>
    )}
  </Fragment>
);

export default ExamScoreHeader;
